export const PAGE_KEYS = Object.freeze({
  STATISTICS: "Статистика",
  SOURCE_DATA: "Исходные данные",
  EXPORT_DATA: "Экспорт данных",
  REPORTS: "Формирование отчётов",
  POSTS_SEARCH: "Поиск по постам",
  DYNAMICS: "Динамика ПЭС",
  DYNAMICS_CONTEXT: "Динамика ПЭС -> Авторы и активность",
  DYNAMICS_SEASON: "Индекс сезонной эмоциональной напряженности",
  DYNAMICS_TIME_SERIES: "Временные ряды индекса эмоциональной напряженности",
  USERS: "Пользователи",
  EMOTIVE: "Эмотивный анализ",
  EMOTIVE_COMMUNITIES: "Сравнение по сообществам",
  EMOTIVE_AVERAGE: "Сравнение эмоций в среднем",
  EMOTIVE_REASONS: "Причины эмоций",
  EMOTIVE_REASONS_DATA: "Причины эмоций -> Данные анализа",
  EMOTIVE_REASONS_WORDS: "Причины эмоций -> Причины эмоций",
  DISCUSSIONS: "Анализ дискуссий",
  DISCUSSIONS_ACTIVITY: "Анализ дискуссий -> Активность дискуссий",
  DISCUSSIONS_COMMUNITY: "Анализ дискуссий -> Активность по сообществам",
  DISCUSSIONS_ANOMALY: "Анализ дискуссий -> Аномальные дискуссии",
  DISCUSSIONS_MARKERS: "Анализ дискуссий -> Психолингвистические показатели",
  DISCUSSIONS_DETAILS: "Анализ дискуссий -> Детали дискуссий",
  TOPIC_INTENSITY: "Интенсивность тем",
  THEMATIC: "Тематический анализ",
  PSYCHOLINGUISTIC: "Психолингвистический анализ",
  PARSING: "Парсинг",
  ANALYSIS: "Анализ",
  DATABASE_ADMIN: "Редактор БД",
  DICTIONARIES: "Словари",
  MONITORING: "Мониторинг сессий",
  GLOSSARY: "Глоссарий",
  ADMINISTRATION: "Администрирование",
});

export const ACCESS_PAGES = Object.freeze(Object.values(PAGE_KEYS));

export const DISCUSSION_ROUTES = Object.freeze([
  { page: PAGE_KEYS.DISCUSSIONS_ACTIVITY, path: "/diss" },
  { page: PAGE_KEYS.DISCUSSIONS_COMMUNITY, path: "/diss/community-activity" },
  { page: PAGE_KEYS.DISCUSSIONS_ANOMALY, path: "/diss/anomaly" },
  { page: PAGE_KEYS.DISCUSSIONS_MARKERS, path: "/diss/markers" },
  { page: PAGE_KEYS.DISCUSSIONS_DETAILS, path: "/diss/disscussions" },
]);

export const ADMIN_SECTION_PAGES = Object.freeze([
  PAGE_KEYS.PARSING,
  PAGE_KEYS.ANALYSIS,
  PAGE_KEYS.DATABASE_ADMIN,
  PAGE_KEYS.DICTIONARIES,
  PAGE_KEYS.STATISTICS,
  PAGE_KEYS.MONITORING,
  PAGE_KEYS.SOURCE_DATA,
  PAGE_KEYS.EXPORT_DATA,
  PAGE_KEYS.REPORTS,
]);

export const hasEmotiveAccess = (allowedPages = []) =>
  allowedPages.includes(PAGE_KEYS.EMOTIVE) &&
  (
    allowedPages.includes(PAGE_KEYS.EMOTIVE_COMMUNITIES) ||
    allowedPages.includes(PAGE_KEYS.EMOTIVE_AVERAGE) ||
    allowedPages.includes(PAGE_KEYS.ADMINISTRATION) ||
    (
      allowedPages.includes(PAGE_KEYS.EMOTIVE_REASONS) &&
      (
        allowedPages.includes(PAGE_KEYS.EMOTIVE_REASONS_DATA) ||
        allowedPages.includes(PAGE_KEYS.EMOTIVE_REASONS_WORDS)
      )
    )
  );

export const hasAdminSectionAccess = (allowedPages = []) =>
  allowedPages.includes(PAGE_KEYS.ADMINISTRATION) &&
  ADMIN_SECTION_PAGES.some((page) => allowedPages.includes(page));

export const getFirstAllowedDiscussionPath = (allowedPages = []) => {
  if (!allowedPages.includes(PAGE_KEYS.DISCUSSIONS)) return null;
  return DISCUSSION_ROUTES.find(({ page }) => allowedPages.includes(page))?.path || null;
};

export const getAllowedPages = (accessList) => {
  if (!Array.isArray(accessList)) return [];

  // В существующей модели can_view=true означает установленный администратором запрет.
  const deniedPages = new Set(
    accessList
      .filter((access) => access?.can_view === true)
      .map((access) => access.page)
  );

  return ACCESS_PAGES.filter((page) => !deniedPages.has(page));
};

export const getFallbackPath = (allowedPages = [], user = null) => {
  const candidates = [
    [PAGE_KEYS.DYNAMICS, "/"],
    [PAGE_KEYS.POSTS_SEARCH, "/posts-search"],
    [PAGE_KEYS.USERS, "/pol"],
    [PAGE_KEYS.THEMATIC, "/topics-analysis"],
    [PAGE_KEYS.PSYCHOLINGUISTIC, "/text-markers"],
    [PAGE_KEYS.GLOSSARY, "/glo"],
    [PAGE_KEYS.STATISTICS, "/stat"],
  ];

  for (const [page, path] of candidates) {
    if (allowedPages.includes(page)) return path;
  }

  if (hasEmotiveAccess(allowedPages)) return "/emotive-analysis";

  const discussionPath = getFirstAllowedDiscussionPath(allowedPages);
  if (discussionPath) return discussionPath;

  if (user?.role === "admin" && hasAdminSectionAccess(allowedPages)) {
    return "/admin";
  }

  return "/access-denied";
};
